"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWidgetExecutionsHandler = void 0;
// (C) 2021-2022 GoodData Corporation
var react_1 = require("react");
var useDispatchDashboardCommand_1 = require("./useDispatchDashboardCommand");
var commands_1 = require("../commands");
/**
 * Provides callbacks to integrate with the executionResults slice.
 * @internal
 */
function useWidgetExecutionsHandler(widgetRef) {
    var startLoading = useDispatchDashboardCommand_1.useDispatchDashboardCommand(commands_1.setExecutionResultLoading);
    var setData = useDispatchDashboardCommand_1.useDispatchDashboardCommand(commands_1.setExecutionResultData);
    var setError = useDispatchDashboardCommand_1.useDispatchDashboardCommand(commands_1.setExecutionResultError);
    var onError = react_1.useCallback(function (error) {
        setError(widgetRef, error);
    }, [widgetRef]);
    var onSuccess = react_1.useCallback(function (executionResult, warnings) {
        setData(widgetRef, executionResult, warnings);
    }, [widgetRef]);
    var onPushData = react_1.useCallback(function (data) {
        if (data.dataView) {
            onSuccess(data.dataView.result, data.dataView.warnings);
        }
    }, [widgetRef, onSuccess]);
    var onLoadingChanged = react_1.useCallback(function (_a) {
        var isLoading = _a.isLoading;
        if (isLoading) {
            startLoading(widgetRef);
        }
    }, [widgetRef]);
    return {
        onLoadingChanged: onLoadingChanged,
        onError: onError,
        onSuccess: onSuccess,
        onPushData: onPushData,
    };
}
exports.useWidgetExecutionsHandler = useWidgetExecutionsHandler;
//# sourceMappingURL=useWidgetExecutionsHandler.js.map